import { mdiCheck, mdiClose } from '@mdi/js';
import { Col, Row } from 'antd';
import type { CheckListItemValue, CheckListProps } from 'common/models';
import Icon from 'components/Icon/Icon';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  checkListProps: CheckListProps;
  title?: string;
  data: CheckListItemValue[];
}

const renderValueIcon = (value?: boolean) => {
  if (value === true) {
    return (
      <Col span={6}>
        <Icon path={mdiCheck} className="text-success" />
      </Col>
    );
  }

  if (value === false) {
    return (
      <Col span={3} offset={3}>
        <Icon path={mdiClose} className="text-danger" />
      </Col>
    );
  }

  return null;
};

const CustomDataCheckList: React.FC<Props> = (props): React.ReactElement => {
  const { checkListProps, data, title } = props;

  const { t } = useCustomTranslation();

  return (
    <div className="CheckList">
      {title && <div className="CheckList_title">{title}</div>}
      <Row gutter={16} className="CheckList_header">
        <Col span={checkListProps?.showIndex ? 8 : 10} offset={checkListProps?.showIndex ? 2 : 0}>
          {checkListProps.itemLabel
            ? checkListProps.itemLabel
            : t('customData.checkListActivityLabel')}
        </Col>
        <Col span={3}>
          {checkListProps?.trueLabel ? checkListProps.trueLabel : t('misc.okText')}
        </Col>
        <Col span={3}>
          {checkListProps?.falseLabel ? checkListProps.falseLabel : t('misc.noText')}
        </Col>
        <Col span={8}>
          {checkListProps?.descriptionLabel
            ? checkListProps.descriptionLabel
            : t('misc.description')}
        </Col>
      </Row>
      {checkListProps.options?.map((option, index) => {
        const checkListItemValue = data.find((x) => x.id === option.id.toString());

        return (
          <Row key={option.id} gutter={16} className="CheckList_item">
            {checkListProps?.showIndex && <Col span={2}>{index + 1}</Col>}
            <Col span={checkListProps?.showIndex ? 8 : 10}>{option.label}</Col>
            {renderValueIcon(checkListItemValue?.value)}
            <Col span={8} className="CheckList_item-description">
              <div>{checkListItemValue?.description}</div>
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default CustomDataCheckList;
